<template>
  <div>
    <material-table
      ref="materialTable"
      :table-data.sync="materialList"
      :table-config-fun="setTableConfig"
      :is-lowest-price="true"
      :is-factory-disabled="false"
      :is-address-select="true"
      :address-required="true"
      :item-code-required="false"
      :page-sizes="[10, 20, 30, 50, 100]"
      :tax-rate-options="taxRateOptions"
      table-id="tempCode"
      :can-edit="canEdit"
      :can-add="!isEdit"
      :is-unit-type-disabled="isEdit"
      :echo-list.sync="selectedMaterials"
      @tableDataUpdate="tableDataUpdate"
    >
      <template v-slot:otherOperate>
        <el-button class="m-l-10" plain @click="handleBatchClear">
          批量清空品目编码
        </el-button>

        <el-button class="m-l-10" plain @click="handleBatchDialog('showSelectEmployeeDialog')">
          批量设置采购执行人
        </el-button>

        <el-button class="m-l-10" plain @click="handleBatchDialog('showSubjectCategoryDialog')">
          批量设置科目分类类别
        </el-button>

        <el-button class="m-l-10" plain @click="handleBatchDialog('showAddressDialog')">
          批量选择交货地点
        </el-button>

        <el-button class="m-l-10" plain @click="handleBatchDialog('showDeptDialog')">
          批量设置使用部门
        </el-button>
      </template>

      <template v-slot:price="{ row, $index }">
        <span
          v-if="
            Object.prototype.toString.call(row.price) === '[object String]' &&
              row.price != ''
          "
        >
          {{ row.price }}
          <el-button type="text" @click="openDrawer(row, $index)">
            历史价格
          </el-button>
        </span>
        <span
          v-else-if="
            Object.prototype.toString.call(row.price) === '[object Object]'
          "
        >
          {{ row.price.noRateWinPrice }}
          <span v-if="row.price.winTime">({{ row.price.winTime }})</span>
          |
          <el-button type="text" @click="openDrawer(row, $index)">
            历史价格
          </el-button>
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:subType="{ row }">
        {{ getSubTypeLabel(row.subType) }}
      </template>
    </material-table>

    <!-- 批量设置科目分配类别 -->
    <subject-category-dialog
      v-model="showSubjectCategoryDialog"
      @confirm="subjectCategoryConfirm"
    />
    <!--采购执行人-->
    <select-employee-dialog
      title="选择采购执行人"
      :show-dialog.sync="showSelectEmployeeDialog"
      @confirm="setExecutorConfirm"
    />

    <!-- 批量修改使用部门 -->
    <use-dept-dialog v-model="showDeptDialog" @confirm="departConfirm" />

    <!-- 批量选择交货地点 -->
    <address-dialog v-model="showAddressDialog" @confirm="addressConfirm" />

    <!-- 查看历史价格 -->
    <lowest-price-drawer
      v-model="isDrawerShow"
      :is-edit="false"
      :row-data="rowData"
      @selectHandel="selectHandel"
    />
  </div>
</template>

<script>
import MaterialTable from '@/components/common/MaterialComponent/index'
import LowestPriceDrawer from '@/components/purchase-demand/LowestPriceDrawer'
import UseDeptDialog from './UseDeptDialog'
import AddressDialog from './AddressDialog'
import SubjectCategoryDialog from './SubjectCategoryDialog'
import SelectEmployeeDialog from '@/components/common/SelectEmployeeDialog.vue'

// 数据字典
import {
  purchaseStatusDict,
  purchaseDemandUnitTaxRateDict,
  purchaseDemandSubTypeDict
} from '@/dictionary/purchase-demand'

export default {
  name: 'ApplyMaterialTable',
  components: {
    SelectEmployeeDialog,
    MaterialTable,
    LowestPriceDrawer,
    UseDeptDialog,
    AddressDialog,
    SubjectCategoryDialog
  },

  props: {
    // 表单页-新增/编辑
    isEdit: {
      type: Boolean,
      default: false
    },

    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 表单页/详情页-是否是可编辑的
    canEdit: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      // 品目税率
      taxRateOptions: purchaseDemandUnitTaxRateDict.dictArray,

      // 设置科目类别弹窗
      showSubjectCategoryDialog: false,

      // 交货地点弹窗
      showAddressDialog: false,

      // 使用部门弹窗
      showDeptDialog: false,

      // 采购执行人弹窗
      showSelectEmployeeDialog: false,

      /**
       * 品目
       */
      // materialList: [],
      selectedMaterials: [],

      /**
       * 历史价格
       */
      isDrawerShow: false,
      itemIndex: 0,
      rowData: null
    }
  },

  computed: {
    materialList: {
      get() {
        return [...(this.tableData || [])]
      },
      set(val) {
        this.$emit('update:tableData', val || [])
      }
    }
  },

  methods: {
    // 修改品目表格展示
    setTableConfig(tableConfig) {
      let priceIndex = 0
      tableConfig.map((item, index) => {
        if (item.prop == 'remarks') {
          tableConfig.splice(index, 1)
        }
        if (item.prop == 'deliveryAddress') {
          item.filter = value => (value ? value.split(',')?.[1] || '-' : '-')
          priceIndex = index
        }

        if (item.prop == 'unitPrice') {
          item.label = '预算不含税单价(元)'
          item.minWidth = 160
        }

        if (item.prop == 'totalPrice') {
          item.label = '预算不含税总价(元)'
          item.minWidth = 160
        }
      })
      tableConfig.splice(
        priceIndex,
        0,
        {
          label: '历史不含税最低价(元)',
          slotName: 'price',
          minWidth: 300
        },
        {
          label: '工厂编码',
          prop: 'factory',
          minWidth: 160
        }
      )
      tableConfig.push({
        label: '采购状态',
        prop: 'purchaseStatus',
        tagDict: purchaseStatusDict
      })
      tableConfig.push({ label: '使用部门', prop: 'useDept' })
      tableConfig.push({
        label: '科目分配类别',
        prop: 'subType',
        slotName: 'subType',
        width: 140
      })
      tableConfig.push({
        label: '采购执行人',
        prop: 'executorName',
        addFields: 'executorId',
        width: 140
      })
      const temp = [...tableConfig]
      return temp
    },

    // 科目分配类别
    getSubTypeLabel(value) {
      return value
        ? purchaseDemandSubTypeDict.translate(value)?.label
        : value == purchaseDemandSubTypeDict.BLANK.value
          ? purchaseDemandSubTypeDict.BLANK.label
          : '-'
    },

    /**
     * 批量清空品目编码
     */
    handleBatchClear() {
      if (this.selectedMaterials.length === 0) {
        this.$message.warning('请先选择需要设置的品目')
        return false
      }

      this.$confirm('是否清空品目编码，清空后不可撤回', '批量清空品目编码', {
        type: 'warning',
        center: true
      }).then(() => {
        this.handleBatchConfirm(null, 'itemCode')
      })
    },

    /**
     * 打开批量弹窗
     */
    handleBatchDialog(dialogFields) {
      if (this.selectedMaterials.length === 0) {
        this.$message.warning('请先选择需要设置的品目')
        return false
      }
      this[dialogFields] = true
    },

    // 设置科目分配类别确认
    subjectCategoryConfirm(value) {
      this.handleBatchConfirm(value, 'subType')
    },

    // 设置使用部门确认
    departConfirm(value) {
      this.handleBatchConfirm(value, 'useDept')
    },

    // 设置交货地点确认
    addressConfirm(value) {
      this.handleBatchConfirm(value, 'address')
    },

    // 设置采购执行人确认
    setExecutorConfirm(employee) {
      this.handleBatchConfirm(employee, 'executor')
    },

    /**
     * 弹窗批量确认
     * @param value 值
     * @param type 批量设置类型
     * subType 科目
     * address 地址
     * useDept 使用部门
     * executor 采购执行人
     * itemCode 品目编码
     */
    handleBatchConfirm(value, type) {
      // 获取已选项在品目列表中的下标
      const tempIndexArray = this.selectedMaterials.map(s => {
        return this.materialList.findIndex(m => m === s)
      })

      // 根据已选项的下标设置品目数据
      const tempArray = this.materialList.map((v, index) => {
        const tempObj = type === 'subType'
          ? { subType: tempIndexArray.includes(index) ? value : v.subType }
          : type === 'address'
            ? {
              factory: tempIndexArray.includes(index)
                ? value?.factory || ''
                : v.factory,
              deliveryAddress: tempIndexArray.includes(index)
                ? value?.deliveryAddress || ''
                : v.deliveryAddress
            }
            : type === 'useDept'
              ? { useDept: tempIndexArray.includes(index) ? value : v.useDept }
              : type === 'executor'
                ? {
                  executorId: tempIndexArray.includes(index) ? value?.employeeId : v.executorId,
                  executorName: tempIndexArray.includes(index) ? value?.name : v.executorName
                }
                : { itemCode: tempIndexArray.includes(index) ? '' : v.itemCode }

        return { ...v, ...tempObj }
      })

      this.materialList = [...tempArray]
      this.$message.success('操作成功')

      this.selectedMaterials = []
      this.$refs.materialTable?.$refs?.materialItemTable?.clearSelection()
    },

    // 品目表格更新
    tableDataUpdate(materialList, itemCode, isAdd) {},

    /**
     * 历史价格
     */
    openDrawer(row, index) {
      this.rowData = row
      this.itemIndex = index
      this.isDrawerShow = true
    },

    selectHandel(row) {
      this.$refs.materialTable.materialList.map((item, index) => {
        if (index === this.itemIndex) {
          item.price = { ...row }
        }
      })
      this.$refs.materialTable.materialList.push()
    },

    /**
     * 获取品目列表
     */
    getItemList() {
      return this.$refs.materialTable.materialList || []
    }
  }
}
</script>

<style lang="scss" scoped></style>
